import { EllipsisIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu as Menu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

export type DropdownMenuOption = { label: string; onClick?: () => void; disabled?: boolean };

/**
 * A page's "More actions" kebab. A disabled item does nothing (D25); an item with no onClick
 * (the MCE page's Duplicate and Delete) is a no-op rather than the error it was.
 */
const DropdownMenu = ({ options }: { options: DropdownMenuOption[] }) => (
  <Menu>
    <DropdownMenuTrigger render={<Button variant="ghost" size="icon" aria-label="More actions" />}>
      <EllipsisIcon className="size-6!" />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-[200px] rounded-xl">
      {options.map((option) => (
        <DropdownMenuItem key={option.label} disabled={!!option.disabled} onClick={() => option.onClick?.()} className="p-2 font-medium">
          {option.label}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </Menu>
);

export default DropdownMenu;
